
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'
import SpeedkitImage from '#speedkit/components/SpeedkitImage'
import speedkitHydrate from '#speedkit/hydrate'

export default {
  name: 'HomePage',
  scrollToTop: true,
  head: {
    htmlAttrs: {
      lang: 'es',
    },
    title: 'Editor de vídeo y audio en línea (gratuito y sencillo)',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Amplifique su podcast convirtiéndolo en un vídeo en forma de onda para compartirlo en Facebook, Twitter e Instagram.',
      },
    ],
  },
  components: {
    FooterSection: speedkitHydrate(() => import('@/components/FooterSection.vue')),
    LogoCloud: speedkitHydrate(() => import('@/components/global/LogoCloud.vue')),
    SpeedkitPicture,
    SpeedkitImage,
  },
  data() {
    return {
      user: null,
      showMobileMenu: false,
    }
  },
  created() {
    this.user = this.$fire.auth.currentUser
  },
}
